// Mirrors backend/src/constants/recommendationCategories.ts - keep both in
// sync by hand since the CMS and touchscreen frontend both need this list
// and neither currently fetches it from the API.
export const RECOMMENDATION_CATEGORIES = [
  'Great Ocean Road & Nature',
  'Beach & Water',
  'Food & Drink',
  'Family & Kids',
  'Arts & History',
  'Shopping',
  'Wildlife',
];
